import { PageSizes, PDFDocument } from 'pdf-lib';

/**
 * Normalizes any image blob to a PDF blob
 * Preserves PDFs as-is, converts images to PDF format
 */
export const normalizeToPdf = async (blob: Blob): Promise<Blob> => {
  if (blob.type === 'application/pdf') {
    return blob;
  }

  const pdfDocument = await PDFDocument.create();
  const imageBuffer = await blob.arrayBuffer();

  let image = null;
  if (blob.type === 'image/png') {
    image = await pdfDocument.embedPng(imageBuffer);
  } else if (blob.type === 'image/jpg' || blob.type === 'image/jpeg') {
    image = await pdfDocument.embedJpg(imageBuffer);
  }

  if (!image) {
    return blob;
  }

  const page = pdfDocument.addPage(PageSizes.Letter);
  const scaled = image.scale(
    Math.min(page.getMediaBox().width / image.width, 600 / image.height),
  );

  // Calculate coordinates to center the image
  const pageWidth = page.getMediaBox().width;
  const pageHeight = page.getMediaBox().height;
  const x = (pageWidth - scaled.width) / 2;
  const y = (pageHeight - scaled.height) / 2;

  page.drawImage(image, {
    x,
    y,
    width: scaled.width,
    height: scaled.height,
  });

  const pdfBytes = await pdfDocument.save();
  return new Blob([pdfBytes], { type: 'application/pdf' });
};
